import { AfterViewInit, Component, ElementRef, Injector, Input, OnInit, QueryList, Renderer2, SystemJsNgModuleLoader, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { LoadedRouterConfig, Route } from '@angular/router/src/config';
import * as $ from 'jquery';
import { cloneDeep } from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SharedDataService, User } from 'orv-ui-base-lib';

import { AuthService } from '../../@core/auth/auth.service';
import { AclService } from '../../@core/data/acl.service';


@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html'
})
export class SidebarComponent implements AfterViewInit, OnInit {

	// this is for the open close
	isActive = true;
	showMenu = '';
	showSubMenu = '';
	@Input() margin: number;

	// filtering the menu
	searchMenu: string = '';
	menuToFilter: QueryList<ElementRef>;
	@ViewChildren('menu') menu: QueryList<ElementRef>;
	refreshingSidebar = false;

	urls: any[];
	mainpaths: string[];
	loggedUser: User;
	@ViewChild('container', { read: ViewContainerRef }) container: ViewContainerRef;

	constructor(private renderer: Renderer2,
		private sharedDataService: SharedDataService,
		private router: Router,
		private deviceService: DeviceDetectorService,
		private authService: AuthService,
		private aclService: AclService,
		private loader: SystemJsNgModuleLoader,
		private inj: Injector,
		private vcRef: ViewContainerRef) {

		this.sharedDataService.currentToken.subscribe(token => {
			this.refreshingSidebar = true;
			setTimeout(() => {
				this.refreshingSidebar = false;
			}, 200);
		});


		this.sharedDataService.currentLoggedUser.subscribe(user => {
			if (user) {
				this.loggedUser = user;
			}
		});
	}

	ngOnInit(): void {
	}

	addExpandClass(element: any) {
		if (element === this.showMenu) {
			this.showMenu = '0';
		} else {
			this.showMenu = element;
		}
	}
	addActiveClass(element: any) {
		if (element === this.showSubMenu) {
			this.showSubMenu = '0';
		} else {
			this.showSubMenu = element;
		}
	}
	eventCalled() {
		this.isActive = !this.isActive;
	}
	// End open close
	ngAfterViewInit() {
		if (this.deviceService.isDesktop()) {
			$(() => {
				$('.sidebartoggler').on('click', () => {
					if ($('body').hasClass('mini-sidebar')) {
						this.maximize();
					} else {
						this.minimize();
					}
				});
			});
			if (this.isCollapsedFromCookie()) {
				this.minimize();
			} else {
				$('.scroll-sidebar, .slimScrollDiv')
					.css('overflow', 'auto');
			}
		}
	}

	maximize(): void {
		$('body').trigger('resize');
		$('.scroll-sidebar, .slimScrollDiv')
			.css('overflow', '')
			.css('overflow', 'auto')
			.parent()
			.css('overflow', 'visible');
		$('body').removeClass('mini-sidebar');
		$('.navbar-brand span').show();
		$('.search-input').show();
		// $(".sidebartoggler i").addClass("ti-menu");
	}

	minimize(): void {
		$('body').trigger('resize');
		$('.scroll-sidebar, .slimScrollDiv')
			.css('overflow', '')
			.css('overflow-x', 'visible')
			.parent()
			.css('overflow', 'visible');
		$('body').addClass('mini-sidebar');
		$('.navbar-brand span').hide();
		$('.search-input').hide();
		// $(".sidebartoggler i").removeClass("ti-menu");
	}

	filterMenu(event: string) {
		this.menuToFilter = cloneDeep(this.menu);
		this.menuToFilter.forEach(item => {
			if (!item.nativeElement.innerText.toLowerCase().includes(event.toLowerCase())) {
				this.renderer.setStyle(item.nativeElement, 'display', 'none');
			} else {
				this.renderer.setStyle(item.nativeElement, 'display', 'inherit');
			}
		});
	}

	isCollapsedFromCookie(): boolean {
		return this.authService.getSidebarCookie() === 'true';
	}

	startRedirecting(index: number) {
		const main = this.mainpaths[index];
		// this.router.navigateByUrl(main, { skipLocationChange: true });
		console.log('main', main);
		if (!this.redirectUser(main)) {
			if (index < this.mainpaths.length - 1)
				this.startRedirecting(index + 1);
		}

		console.log('this.rout', this.router);
	}

	redirectUser(mainroute: string) {
		this.urls = [];

		this.enumPaths('', this.router.config, mainroute);
		this.urls = this.urls.filter(e => e.parent === mainroute && e.data && e.data.menusection);
		let url;


		for (let i = 0; i < this.urls.length; i++) {
			const element = this.urls[i];
			if (element && element.data) {
				if (element.data.aclFeatures) {
					if (this.aclService.hasPermission(element.data.aclFeatures)) {
						url = element.full;
						break;
					}
				} else if (element.data.section) {
					if (this.aclService.hasPermissionInSection(element.data.section)) {
						url = element.full;
						break;
					}
				}
				// console.log('url', url);
			}
		}
		if (url) {
			this.router.navigateByUrl(url);
			return true;
		} return false;
	}

	enumPaths(parent: string, routes: Route[], mainroute?: string) {
		const getFullPath = (path?: string) => {
			if (path) {
				return parent + '/' + path;
			}

			return parent;
		};

		for (let i = 0; i < routes.length; i++) {
			const route = routes[i];
			const fullPath = getFullPath(route.path);


			if (route.data && mainroute.indexOf(route.data.parent) >= 0) {
				this.urls.push({
					parent: parent,
					child: route.path,
					data: route.data,
					full: fullPath
				});
				// console.log('match', mainroute, fullPath);
			} else {
				// console.log('notmatch', mainroute, fullPath);
			}


			if (route.children /*&& route.children.length > 0*/) {
				this.enumPaths(fullPath, route.children, mainroute);
			}

			if (route.loadChildren && route.loadChildren.length > 0) {
				const routerConfig = <LoadedRouterConfig>(<any>route)['_loadedConfig'];
				if (routerConfig) {
					this.enumPaths(fullPath, routerConfig.routes, mainroute);
				}
			}
		}
	}

}
